import { useState } from 'react';

import { useActiveShortcuts, useShortcut } from '../../shortcuts.ts';
import { Button } from '../Button/Button.tsx';
import { Dialog, DialogActions } from '../Dialog/Dialog.tsx';
import { Kbd } from '../Kbd/Kbd.tsx';
import styles from './ShortcutsHelp.module.css';

export const SHORTCUTS_HELP_COMBO = '?';

/**
 * The "?" overlay (DESIGN.md §10): lists the keyboard shortcuts active on this screen.
 * Screens add to it by passing `description` to `useShortcut`. The shell mounts it once.
 */
export function ShortcutsHelp() {
  const [open, setOpen] = useState(false);
  useShortcut(
    SHORTCUTS_HELP_COMBO,
    () => {
      setOpen(true);
    },
    { description: 'Show keyboard shortcuts' },
  );
  const shortcuts = useActiveShortcuts();
  return (
    <Dialog title="Keyboard shortcuts" isOpen={open} onOpenChange={setOpen}>
      {({ close }) => (
        <>
          <p className={styles.intro}>
            Single-key shortcuts don't work while you are typing in a field. Shortcuts with Ctrl
            work everywhere.
          </p>
          <ul className={styles.list} aria-label="Shortcuts on this screen">
            {shortcuts.map((s) => (
              <li key={`${s.combo}|${s.description}`} className={styles.row}>
                <span>{s.description}</span>
                <Kbd combo={s.combo} persistent />
              </li>
            ))}
          </ul>
          <DialogActions>
            <Button variant="primary" onPress={close}>
              Close
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
